<script lang="ts">
  export let title: string
  export let description: string
  export let thereIsAmbassador: boolean = false
</script>

<section class="course-features">
  {#if title || description}
    {#if !thereIsAmbassador}
      <div class="features-row-info">
        {#if title}
          <h2 class="features-title">
            {@html title}
          </h2>
        {/if}
        {#if description}
          <p class="features-description">
            {@html description}
          </p>
        {/if}
      </div>
    {/if}
    <div class="features-row-boxes">
      <slot name="boxes" />
    </div>

    <div class="features-row-footnotes">
      <slot name="footnotes" />
    </div>
  {:else}
    {#if !thereIsAmbassador}
      <div class="features-row-headernotes">
        <slot name="headernotes" />
      </div>
    {/if}
    <div class="features-row-boxes">
      <slot name="boxes" />
    </div>

    <div class="features-row-footnotes">
      <slot name="footnotes" />
    </div>
  {/if}

</section>

<style type="text/scss" lang="scss" scoped>
  .course-features {
  }

  .features-row-info {
    @apply flex flex-col;
    @apply lg:flex-row lg:my-16;
  }

  .features-title {
    @apply my-7;
    @apply lg:pr-16;

    @apply text-xl lg:text-4xl;
  }

  .features-description {
    @apply leading-relaxed;
    @apply lg:mt-6;
    @apply lg:pl-16 lg:pr-8 lg:mt-auto;
  }

  .features-partners {
    @apply flex items-end;
    @apply lg:mt-24;
    @apply mb-7;
  }
  :global(.course-features .features-partners > *) {
    @apply max-w-[150px] h-auto max-h-12;
  }
  :global(.course-features .features-partners > * + *) {
    @apply ml-2;
  }
  .features-row-headernotes {
    @apply my-6;
  }

  .features-row-footnotes {
    @apply my-6;
  }
</style>
